module.exports = __webpack_public_path__ + "img/seminar (64).1485b915.jpg";